<template>
  <p class="text-justify" :id="itemKey">
    {{ textObservation }}
    <span v-if="observation.length > 500 && !see_less" @click="changeData(true, true)" style="cursor: pointer"
      class="font-italic text-muted ml-2">Leer más...</span>
    <span v-if="observation.length > 500 && see_less" @click="changeData(false, false)" style="cursor: pointer"
      class="font-italic text-muted ml-2">Ver menos</span>
  </p>
</template>

<script>
export default {
  name: "ObservationReadMore",
  props: ['observation','itemKey'],
  data() {
    return {
      show_all: false,
      see_less: false
    }
  },
  computed: {
    textObservation() {
      let observation = this.observation;
      if (this.observation.length > 500) {
        if (!this.show_all) {
          observation = this.observation.slice(0, 500)
        }
      }
      return observation;
    },
  },
  methods: {
    changeData(bool_1, bool_2) {
      this.show_all = bool_1;
      this.see_less = bool_2;
    }
  }
}
</script>

<style scoped></style>
